import { render } from "./PengajuanKoreksiDetail.vue?vue&type=template&id=6b6fc3c0"
import script from "./PengajuanKoreksiDetail.vue?vue&type=script&lang=js"
export * from "./PengajuanKoreksiDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__